import c0 from './conditional_form_controller';
import c1 from './delayed_display_controller';
import c2 from './dromo_controller';
import c3 from './flash_controller';
import c4 from './map_controller';
import c5 from './multi_step_form_controller';
import c6 from './templated_fields_controller';
import c7 from './time_controller';
import c8 from './view_mode_toggle_controller';
import c9 from './with_floating/positioner_controller';
import c10 from './with_floating/visibility_controller';
export const definitions = [
	{identifier: 'conditional-form', controllerConstructor: c0},
	{identifier: 'delayed-display', controllerConstructor: c1},
	{identifier: 'dromo', controllerConstructor: c2},
	{identifier: 'flash', controllerConstructor: c3},
	{identifier: 'map', controllerConstructor: c4},
	{identifier: 'multi-step-form', controllerConstructor: c5},
	{identifier: 'templated-fields', controllerConstructor: c6},
	{identifier: 'time', controllerConstructor: c7},
	{identifier: 'view-mode-toggle', controllerConstructor: c8},
	{identifier: 'with-floating--positioner', controllerConstructor: c9},
	{identifier: 'with-floating--visibility', controllerConstructor: c10},
];
